'use client'

import React, { useState } from 'react'
import { AnimatePresence, motion } from 'motion/react'

import { SerializedEditorState, SerializedLexicalNode } from '@payloadcms/richtext-lexical/lexical'

import { HiglightedText } from '@/components/HiglightedText'
import HomeTabContent from '@/components/HomeTabContent'
import { RevealSection } from '@/components/RevealSection'
import { TabSelect } from '@/components/TabSelect'

import type { Media, TabsBlock as TabsBlockType } from '@/payload-types'

export const TabsBlock: React.FC<TabsBlockType> = ({ tabG }) => {
  const [selectedTab, setSelectedTab] = useState<string | undefined>(tabG.tabs?.[0]?.tab.title)

  const handleTabChange = (tabValue: string) => {
    setSelectedTab(tabValue)
  }
  return (
    tabG && (
      <RevealSection stagger className="wrapper lg:py-20">
        {tabG.title && (
          <h2 className="mx-auto mt-2 max-w-4xl text-center font-family-display text-3xl md:text-5xl">
            <HiglightedText
              text={tabG.title}
              textToHighlight={tabG.textToHighlight ?? ''}
              highlightColor="text-evergreen-600"
            />
          </h2>
        )}
        <div className="mt-8 flex w-full flex-col items-start gap-12">
          <TabSelect
            tabs={tabG.tabs?.map((tab) => ({ name: tab.tab.title, value: tab.tab.title })) ?? []}
            onTabChange={handleTabChange}
            value={selectedTab}
            variant="evergreen"
            className="mx-auto w-full max-w-xl"
          />
          <AnimatePresence>
            {tabG.tabs?.map(
              (tabData) =>
                selectedTab === tabData.tab.title && (
                  <motion.div
                    key={tabData.tab.title}
                    initial={{ opacity: 0, y: -10, display: 'none' }}
                    animate={{
                      opacity: 1,
                      display: 'block',
                      y: 0,
                      transition: { duration: 0.3, ease: 'easeIn', delay: 0.15 },
                    }}
                    exit={{ opacity: 0, y: -10, display: 'none' }}
                    transition={{ duration: 0.3, ease: 'easeOut' }}
                    className="relative min-h-125 w-full"
                  >
                    <HomeTabContent
                      key={tabData.tab.title}
                      title={tabData.tab.title}
                      image={tabData.tab.image as Media}
                      content={
                        tabData.tab
                          .content as unknown as SerializedEditorState<SerializedLexicalNode>
                      }
                      type={tabData.tab.type as 'aboutBlock' | 'collectionBlock'}
                      link={tabData.tab.link}
                      join={tabData.tab.join}
                      impactRow={tabData.tab.impactRow}
                      collectionType={tabData.tab.collectionType}
                    />
                  </motion.div>
                ),
            )}
          </AnimatePresence>
        </div>
      </RevealSection>
    )
  )
}
